
import { useState, useRef } from 'react';
import './App.css';
import './assets/css/carve-global.css'
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoute from "./pages/AppRoute/AppRoute";
// import videoFile from './assets/video/video.mp4';
// import eywa from './assets/video/eywamov.mov';
import ChatBox from "./pages/ChatModel/CarveChat";
function App() {
  const [show, setShow] = useState(true);
  const ref = useRef(null);
  const dotsCount = 100;
  const dotsArray = Array.from({ length: dotsCount });

  return (
    <Router future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
      <div className="dot-container">
        {dotsArray.map((_, i) => (
          <span
            key={i}
            className="dots"
            style={{
              '--x-move': `${Math.random() * 2 - 1}`,
              '--y-move': `${Math.random() * 2 - 1}`,
              '--x-start': `${Math.random() * 100}vw`,
              '--y-start': `${Math.random() * 100}vh`,
            }}
          ></span>
        ))}
        {/* <video autoPlay loop muted playsInline id="video-background" style={{ width: "100%", }}>
          <source src={videoFile} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}

        <div className="App">
          <AppRoute />
          <div className="carve-eywa" style={{ display: 'none' }} onClick={() => {
            setShow(!show);
          }}>

          </div>
          {!show && <ChatBox ref={ref} />}
        </div>
      </div>
    </Router>
  );
}

export default App;